import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-420f47b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-center justify-space-between" }
const _hoisted_2 = { class: "value" }

import { withDefaults } from 'vue';
import { AtomInfoCard, AtomToogleButton, AtomSubTitle , AtomBadge} from '@/components/atoms';
import {MoleculeCard} from "@/components/molecules"
import * as comps from '@/components/atoms';
import { IDataFinanceInfo } from '@/types';
interface IProps {
  data: IDataFinanceInfo[];
  title: string;
  footer?: boolean
  loading?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeFinanceInfo',
  props: {
    data: {},
    title: {},
    footer: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ['handleToggle'],
  setup(__props: any, { emit: __emit }) {

const mapComp = {};
const props = __props;
const emit = __emit;

function handleToogleChange($event) {
  emit('handleToggle', $event);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(MoleculeCard), {
    loading: props.loading,
    footer: props.footer,
    title: _ctx.title
  }, {
    footer: _withCtx(() => [
      _renderSlot(_ctx.$slots, "footer")
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (info, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "area-cards-info",
          key: String(index)
        }, [
          _createVNode(comps.AtomSubTitle, {
            "no-margin": "",
            text: info.description
          }, null, 8, ["text"]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("p", _hoisted_2, _toDisplayString(info.value), 1)
          ])
        ]))
      }), 128))
    ]),
    _: 3
  }, 8, ["loading", "footer", "title"]))
}
}

})